import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";

export const mellanoCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
		},
	},
} as const;
